import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import DrawingDock from "../../components/drawing/DrawingDock";
// Drawing dock node. Split from useWidgetOverlays (D0 headroom).
export function useDrawingDockNode(deps) {
    const { showDrawingDock, drawingWorkspace, renderDrawingDock, t, dockPropertiesContent, dockObjectsContent, dockTemplatesContent, forceOpen, } = deps;
    return useMemo(() => {
        if ((!showDrawingDock && !forceOpen) || !drawingWorkspace)
            return null;
        const dockOpen = forceOpen || drawingWorkspace.state.dock.isOpen;
        if (!dockOpen)
            return null;
        const labels = {
            title: t("drawing.dock.title") ?? "Drawing Properties",
            close: t("drawing.dock.close") ?? "Close",
            properties: t("drawing.dock.properties") ?? "Properties",
            objects: t("drawing.dock.objects") ?? "Objects",
            templates: t("drawing.dock.templates") ?? "Templates",
            emptyProperties: t("drawing.dock.emptyProperties") ?? "No properties available",
            emptyObjects: t("drawing.dock.emptyObjects") ?? "No objects selected",
            emptyTemplates: t("drawing.dock.templates") ?? "No templates saved",
            resize: t("drawing.dock.resize") ?? "Resize",
        };
        if (renderDrawingDock) {
            return (_jsx(React.Fragment, { children: renderDrawingDock({
                    isOpen: dockOpen,
                    activeTab: drawingWorkspace.state.dock.activeTab,
                    labels,
                    onClose: () => drawingWorkspace.closeDock(),
                    onTabChange: (tab) => drawingWorkspace.setDockTab(tab),
                    propertiesContent: dockPropertiesContent,
                    objectsContent: dockObjectsContent,
                    templatesContent: dockTemplatesContent,
                }) }, "dock"));
        }
        return (_jsx(DrawingDock, { isOpen: dockOpen, activeTab: drawingWorkspace.state.dock.activeTab, labels: labels, initialDragDelta: drawingWorkspace.state.dock.position, initialSizeDelta: drawingWorkspace.state.dock.sizeDelta, onLayoutChange: ({ dragDelta, sizeDelta }) => drawingWorkspace.setDockLayout({ position: dragDelta, sizeDelta }), onClose: () => drawingWorkspace.closeDock(), onTabChange: (tab) => drawingWorkspace.setDockTab(tab), propertiesContent: dockPropertiesContent, objectsContent: dockObjectsContent, templatesContent: dockTemplatesContent }, "dock"));
    }, [showDrawingDock, forceOpen, drawingWorkspace, renderDrawingDock, t, dockPropertiesContent, dockObjectsContent, dockTemplatesContent]);
}
